import MantineModal from '@ben/orion/mantine-modal';
import Typography, { TypographyVariant } from '@ben/orion/typography';
import { useDocusealEmbedConfig } from '@ben/shared/hooks/use-docuseal-embed-config';
import { DocusealForm } from '@docuseal/react';
import { type JSX } from 'react';
import styled, { css, useTheme } from 'styled-components';

interface DocusealSigningModalProps {
  opened: boolean;
  onClose: () => void;
  title: string;
  closeAriaLabel: string;
  embedSource: string;
  onComplete: () => Promise<void> | void;
}

const DocusealSigningModal = ({
  opened,
  onClose,
  title,
  closeAriaLabel,
  embedSource,
  onComplete,
}: DocusealSigningModalProps): JSX.Element => {
  const docusealConfig = useDocusealEmbedConfig();
  const theme = useTheme();

  return (
    <MantineModal
      opened={opened}
      onClose={onClose}
      size="80%"
      mah="90vh"
      title={title}
    >
      <CenteredTitleModalHeader pb={theme.spacing(1)}>
        <CenteredTitleModalHeaderTitle>
          <Typography variant={TypographyVariant.h3}>{title}</Typography>
        </CenteredTitleModalHeaderTitle>
        <CenteredTitleModalHeaderClose aria-label={closeAriaLabel} />
      </CenteredTitleModalHeader>
      <MantineModal.Body>
        <ModalBody>
          {embedSource && (
            <DocusealForm
              src={embedSource}
              onComplete={() => {
                void Promise.resolve(onComplete()).catch(console.error);
              }}
              {...docusealConfig}
            />
          )}
        </ModalBody>
      </MantineModal.Body>
    </MantineModal>
  );
};

export default DocusealSigningModal;

const ModalBody = styled.div`
  height: 70vh;
`;

const CenteredTitleModalHeader = styled(MantineModal.Header)`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CenteredTitleModalHeaderTitle = styled.div`
  text-align: center;
`;

const CenteredTitleModalHeaderClose = styled(MantineModal.CloseButton)`
  ${({ theme }) => css`
    position: absolute;
    right: ${theme.spacing(5)};
    top: 50%;
    margin: 0;
    transform: translateY(-50%);
  `}
`;
